"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.name = void 0;
const React = __importStar(require("react"));
const react_native_1 = require("react-native");
const native_base_1 = require("native-base");
const native_1 = require("@react-navigation/native");
const async_storage_1 = __importDefault(require("@react-native-async-storage/async-storage"));
const theme_1 = require("theme");
const QuoteDetail_1 = require("components/partial/QuoteDetail");
const MyShoppingCart_1 = require("components/partial/MyShoppingCart");
const Clients_1 = require("components/partial/Clients");
const services_1 = require("services");
const FullScreenLoad_1 = __importDefault(require("components/custom/FullScreenLoad"));
const modal_1 = require("components/modal");
const context_1 = require("components/context");
const constants_1 = require("constants/constants");
const NewQuote_1 = require("types/components/partial/NewQuote");
const hooks_1 = require("components/hooks");
const Quotes = ({ navigation, route }) => {
    const { clientForTransformQuote } = route?.params ?? {};
    const quoteToTranformRef = React.useRef();
    const authContext = React.useContext(context_1.AuthContext);
    (0, native_1.useFocusEffect)(React.useCallback(() => {
        if (clientForTransformQuote && quoteToTranformRef.current) {
            transformQuote(quoteToTranformRef.current, clientForTransformQuote?.id);
            quoteToTranformRef.current = undefined;
        }
    }, [clientForTransformQuote?.id]));
    const [modalMessage, setModalMessage] = React.useState("");
    const [isModalMessageOpen, setIsModalMessageOpen] = React.useState(false);
    const [quotes, setQuotes] = React.useState([]);
    const [query, setQuery] = React.useState("");
    const [queryCallable, setQueryCallable] = React.useState("");
    const [loadingTransform, setLoadingTransform] = React.useState(false);
    const [initialLoading, setInitialLoading] = React.useState(false);
    const [isLoading, setLoading] = React.useState(false);
    const [currentPage, setCurrentPage] = React.useState(1);
    const lastPage = React.useRef(0);
    const listQuotes = React.useCallback(() => {
        const onSuccess = (response) => {
            lastPage.current = response.pages ?? 0;
            setQuotes(response.data);
        };
        (0, services_1.doQuotesList)({
            callback: {
                onSuccess,
                onLoading: setInitialLoading,
            },
            params: {
                data: {
                    q: queryCallable,
                    page: "1",
                },
            },
        });
    }, [queryCallable]);
    const listMoreQuotes = React.useCallback(() => {
        let nextPage = currentPage + 1;
        const onSuccess = (response) => {
            lastPage.current = response.pages ?? 0;
            if ((response.data?.length ?? 0) > 0) {
                setQuotes(quotes => [...(quotes ?? []), ...(response.data ?? [])]);
                setCurrentPage(nextPage);
            }
        };
        (0, services_1.doQuotesList)({
            callback: {
                onSuccess,
                onLoading: setLoading,
            },
            params: {
                data: {
                    q: queryCallable,
                    page: nextPage.toString(),
                },
            },
        });
    }, [queryCallable, currentPage, lastPage]);
    (0, native_1.useFocusEffect)(listQuotes);
    const timeoutId = React.useRef();
    const handleQueryChange = (query) => {
        setQuery(query);
        clearTimeout(timeoutId.current);
        timeoutId.current = setTimeout(() => {
            setQueryCallable(query);
        }, 1000);
    };
    const numColumns = (0, native_base_1.useBreakpointValue)({
        base: 1,
        lg: 2,
    });
    const onQuoteClick = (quoteId, warehouseCode) => {
        navigation.navigate(QuoteDetail_1.name, {
            id: quoteId,
            warehouseCode: warehouseCode,
        });
    };
    const selectClientTotransformQuote = React.useCallback((quote) => {
        quoteToTranformRef.current = quote;
        navigation.navigate(Clients_1.name, {
            origin: "Quotes",
        });
    }, []);
    const transformQuote = React.useCallback((quote, cliid) => {
        const onSuccess = async (response) => {
            await async_storage_1.default.setItem(constants_1.StorageKey.CLIENT_QUOTE_DATA, JSON.stringify(response.cliente));
            await async_storage_1.default.setItem(constants_1.StorageKey.CLIENT_DATA, JSON.stringify(response.cliente));
            authContext?.onClientChange();
            navigation?.jumpTo(MyShoppingCart_1.name, {
                updateProducts: undefined,
                warehouseCode: quote?.almacen,
                quoteClientId: cliid ?? quote?.cliid,
                quoteId: quote?.id,
            });
        };
        const onFail = (msg) => {
            //toast.show({description: msg});
            setModalMessage(msg);
            setIsModalMessageOpen(true);
        };
        (0, services_1.doQuoteTransform)({
            params: {
                data: {
                    cotid: quote?.id,
                    cliid: cliid,
                    almacen: quote?.almacen,
                },
            },
            callback: {
                onSuccess,
                onFail,
                onLoading: setLoadingTransform,
            },
        });
    }, []);
    //delete
    const client = (0, hooks_1.useClient)();
    //delete
    const onRemakePress = (quote) => {
        const onSuccess = async (response) => {
            const params = {
                clientType: response.data?.cliente?.id ? NewQuote_1.EClientType.CLIENT_EXISTENT : NewQuote_1.EClientType.CLIENT_NEW,
                client: response.data?.cliente,
                clientName: response.data?.clienteNombre,
                warehouse: response.data?.almacen,
            };
            console.log("params:", params);
            navigation.navigate({ name: "NewQuoteName", params: params, merge: false });
        };
        const onFail = (msg) => {
            //toast.show({description: msg});
            setModalMessage(msg);
            setIsModalMessageOpen(true);
        };
        (0, services_1.doQuoteRemake)({
            params: {
                data: {
                    cotid: quote?.id,
                },
            },
            callback: {
                onSuccess,
                onFail,
                onLoading: setLoading,
            },
        });
    };
    const renderItem = ({ item }) => (<Quote style={styles.layoutQuote} onQuoteClick={onQuoteClick} quote={item} transformQuote={transformQuote} selectClientTotransformQuote={selectClientTotransformQuote} onRemakePress={onRemakePress}/>);
    return (<>
			<native_base_1.VStack h="100%" style={styles.container} py={{ base: 20, md: 30 }}>
				<native_base_1.HStack w="100%" px={{ base: 20, md: 30 }} justifyContent="flex-end">
					<native_base_1.Input onChangeText={handleQueryChange} value={query} InputRightElement={<native_base_1.Image source={require("images/ic_search.svg")} variant="iconInputRight"/>} placeholder={theme_1.Str.searchForCodeOrClient} style={styles.btnSearchProduct} minW={{ base: "100%", md: "md" }} px="10" borderRadius="50" borderColor="white"/>
				</native_base_1.HStack>

				<native_base_1.View style={styles.layoutQuotes} flex="1">
					<native_base_1.FlatList w="100%" h="100%" px="20" data={quotes} renderItem={renderItem} numColumns={numColumns} key={numColumns} ListFooterComponent={() => (<native_base_1.View style={{ marginBottom: 300 }}>{isLoading && <native_base_1.Spinner size="lg" color="black"/>}</native_base_1.View>)} onScroll={e => {
            let paddingToBottom = 3000;
            paddingToBottom += e.nativeEvent.layoutMeasurement.height;
            var currentOffset = e.nativeEvent.contentOffset.y;
            var direction = currentOffset > 99999999999999999 ? "down" : "up"; //this?.offset ? "down" : "up";
            if (direction === "up") {
                if (e.nativeEvent.contentOffset.y >=
                    e.nativeEvent.contentSize.height - paddingToBottom) {
                    if (!isLoading && currentPage < lastPage.current) {
                        setTimeout(() => {
                            listMoreQuotes();
                        }, 10);
                    }
                }
            }
        }}/>
				</native_base_1.View>
			</native_base_1.VStack>
			<FullScreenLoad_1.default isVisible={initialLoading || loadingTransform}/>
			<modal_1.ModalMessage message={modalMessage} isOpen={isModalMessageOpen} onClose={() => {
            setIsModalMessageOpen(false);
        }}/>
		</>);
};
const Quote = ({ style, onQuoteClick, quote, transformQuote, selectClientTotransformQuote, onRemakePress, }) => {
    const onPress = () => {
        onQuoteClick(quote?.id, quote?.almacen);
    };
    const onSendToOrderPress = () => {
        if (quote?.cliid)
            transformQuote(quote);
        else
            selectClientTotransformQuote(quote);
    };
    const onRemakePressInternal = () => {
        onRemakePress(quote);
    };
    return (<native_base_1.Pressable onPress={onPress} style={[theme_1.Styles.box, style]} minW={{ base: "100%", md: 300 }} mt="15" mx={{ base: 0, md: 10 }} p={{ base: 12, md: 20 }}>
			<native_base_1.HStack style={{
            flexDirection: "row",
            alignItems: "flex-start",
        }}>
				<native_base_1.Text style={{
            marginEnd: 20,
            flex: 1,
        }} variant="h23">
					Código {quote?.id ?? ""}
				</native_base_1.Text>

				<native_base_1.VStack alignItems="flex-end">
					<native_base_1.Button size={{ base: "xs", sm: "xs", md: "sm" }} py="4" borderRadius="30" mb={10} bg={quote?.estadoColor ?? "colorVividYellow1"} _hover={{
            bg: quote?.estadoColorHover ?? "colorVividYellow1",
        }} _text={{ color: "white" }}>
						{quote?.estado ?? ""}
					</native_base_1.Button>
				</native_base_1.VStack>

				{/*!quote?.cliid && (
            <Button onPress={onSendToOrderPress} size="sm">
                {Str.sendToOrder.toUpperCase() +
                    (__DEV__ ? " (dev)" : "")}
            </Button>
                )*/}
			</native_base_1.HStack>
			<native_base_1.HStack alignItems="flex-start">
				<native_base_1.Text style={{
            marginEnd: 20,
            flex: 1,
        }} mt="5" display={quote?.cliente || quote?.generarPedido ? "flex" : "none"} variant="h3">
					{quote?.cliente ?? ""}
				</native_base_1.Text>
				<native_base_1.VStack alignItems="flex-end">
					{quote?.generarPedido && (<native_base_1.Button onPress={onSendToOrderPress} size="sm" mb={10}>
							{theme_1.Str.sendToOrder.toUpperCase()}
						</native_base_1.Button>)}
					<native_base_1.Button onPress={onRemakePressInternal} size="sm">
						{"Recotizar"}
					</native_base_1.Button>
				</native_base_1.VStack>
			</native_base_1.HStack>

			<native_base_1.HStack style={{
            marginTop: 20,
            flexDirection: "row",
            alignItems: "center",
        }}>
				<native_base_1.VStack style={{
            flex: 1,
        }}>
					<native_base_1.Text style={{
            textTransform: "uppercase",
        }} variant="body6">
						{theme_1.Str.totalAmount}
					</native_base_1.Text>
					<native_base_1.Text variant="h3" color="colorVividRed1" mt={{ base: 0, md: 5 }}>
						{quote?.total ?? ""}
					</native_base_1.Text>
				</native_base_1.VStack>
				<native_base_1.VStack style={{
            flex: 1,
            alignItems: "center",
        }}>
					<native_base_1.Text style={{
            textTransform: "uppercase",
        }} variant="body6">
						{theme_1.Str.date}
					</native_base_1.Text>
					<native_base_1.Text mt={{ base: 0, md: 5 }}>{quote?.fecha ?? ""}</native_base_1.Text>
				</native_base_1.VStack>
				<native_base_1.VStack style={{
            flex: 1,
            alignItems: "flex-end",
        }}>
					<native_base_1.Text style={{
            textTransform: "uppercase",
        }} variant="body6">
						{theme_1.Str.hour}
					</native_base_1.Text>
					<native_base_1.Text mt={{ base: 0, md: 5 }}>{quote?.hora ?? ""}</native_base_1.Text>
				</native_base_1.VStack>
			</native_base_1.HStack>
		</native_base_1.Pressable>);
};
const styles = react_native_1.StyleSheet.create({
    container: {
        width: "100%",
        alignItems: "flex-end",
    },
    btnSearchProduct: {},
    btnSearchProductText: {
        flex: 1,
        textAlign: "left",
        fontFamily: theme_1.Fonts.regular,
    },
    btnSearchProductIcon: {
        tintColor: theme_1.Colors.colorGray1,
    },
    layoutQuotes: {
        width: "100%",
        marginTop: 20,
        alignItems: "center",
    },
    layoutQuote: {
        flex: 1,
    },
});
exports.name = "QuotesName";
exports.default = Quotes;
